<template lang="pug">
    div(class="_con _page _row")
        slot
</template>

<script>
    /**
     * This deprecated component is shorthand for `ib-context(page, row)`.
     */
    export default {
        name: 'ib-container'
    }
</script>
